import React from 'react'
import './services.css'
import {BsCheckLg} from 'react-icons/bs'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

    <div className='container services__container'>
      <article className='service'>
        <div className='service_head'>
          <h3>Cinematography & Photography</h3>
        </div>

        <ul className='service_list'>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Documentary Production</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Wedding Filmmaking</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Editorial Shoots</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Fashion Shoots</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Cinematic Storytelling</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Street Photography</p>
          </li>
        </ul>
      </article>

      {/* <article className='service'>
        <div className='service_head'>
          <h3>Website Development</h3>
        </div>

        <ul className='service_list'>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>UI/UX</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Frontend Development</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Backend Development</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Database Services</p>
          </li>
        </ul>
      </article> */}

      <article className='service'>
        <div className='service_head'>
          <h3>Media Research & Consultation</h3>
        </div>

        <ul className='service_list'>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Audience-Focused Strategies</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Cultural Context Integration</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Brand Expansion Planning</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Public Relation & Advertisement</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Trends & Industry Research</p>
          </li>
        </ul>
      </article>
      <article className='service'>
        <div className='service_head'>
          <h3>Project & Team Management</h3>
        </div>

        <ul className='service_list'>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Creative Team Leadership</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Qaulity Control & Review</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Budget & Resource Management</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Client Coordination & Communication</p>
          </li>
          <li>
            <BsCheckLg className='service_list-icon'/>
            <p>Mentorship & Team Development</p>
          </li>
        </ul>
      </article>
      
    </div>
    </section>
  )
}

export default Services